// extracted by mini-css-extract-plugin
export default {"root":"logistics_root__hSzWY","container":"logistics_container__NQuZC"};